/*
  Copyright 2018-2020 National Geographic Society
  Copyright 2021-2022 Impact Observatory

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import { AnalysisTypeEnum } from 'modules/analysis/model';
import React from 'react';
import { connect } from 'react-redux';

import { QUERIES } from '@marapp/earth-shared';

import { useAnalysisResults } from '../../../fetchers';
import { setLayersActive } from '../../../modules/layers/actions';
import {
  resetLocationHighlight,
  setLocationHighlight,
  setMapBounds,
} from '../../../modules/map/actions';
import { ELSACard } from './ELSACard';

export function WithData(props) {
  const ELSA_QUERY = QUERIES.ANALYSIS.getLatest(AnalysisTypeEnum.ELSA);
  const results = useAnalysisResults(ELSA_QUERY);

  return <ELSACard fetchedResults={results} {...props} />;
}

export default connect(
  (state: any) => ({
    activeLayers: state.layers.active,
  }),
  {
    setLayersActive,
    setLocationHighlight,
    resetLocationHighlight,
    setMapBounds,
  }
)(WithData);
